import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "This will permanently delete this resource.", -1)
const _hoisted_2 = { class: "flex flex-wrap w-full md:flex-nowrap" }
const _hoisted_3 = { class: "w-full md:w-1/2" }
const _hoisted_4 = { class: "mt-4 text-3xl font-medium" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2 text-xl font-medium"
}
const _hoisted_6 = { class: "capitalize" }
const _hoisted_7 = {
  key: 1,
  class: "px-2 mt-4 text-sm text-white capitalize rounded-full bg-success w-fit"
}
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_10 = { class: "pt-0 pb-2 capitalize md:pb-0" }
const _hoisted_11 = { class: "pt-0 pb-2 capitalize md:pb-0" }
const _hoisted_12 = { class: "md:space-y-2 md:mt-2" }
const _hoisted_13 = { class: "flex items-center space-x-4" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "mt-5 border" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "px-4 py-4 even:bg-gray-200"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 0,
  class: "mt-5 mb-8"
}
const _hoisted_20 = ["innerHTML"]

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import RoleGuard from "@/components/RoleGuard.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import ReadonlyTags from "@/components/ReadonlyTags.vue";
import RouterButton from "@/components/RouterButton.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";

import api from "@/api/api";
import { Resource } from "@/types";
import { useUserStore } from "@/store";
import { useGlobalStore } from "@/store";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcePage',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const { user, userIsAdmin } = storeToRefs(useUserStore());

const isConfirmationModalOpen = ref(false);
const resource = ref({} as Resource);

function getResourceType(type: string) {
  const types = [
    {
      key: "Activity",
      value: "activity",
    },
    {
      key: "Facilitation resources",
      value: "facilitation-aid",
    },
    {
      key: " Advocacy and marketing materials",
      value: "club-promotion",
    },
    {
      key: " Brick Club resources",
      value: "supporting-asset",
    },
    {
      key: "Training resources",
      value: "training-resources",
    },
  ];

  return types.filter(t => t.value === type)[0].key;
}

function formatBytes(bytes: number) {
  if (bytes == 0) return "0 Bytes";
  var k = 1024,
    sizes = ["b", "kb", "mb"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

async function deleteResource() {
  const response = await api.resources.deleteResource(Number(route.params.id));

  if (response.data.deleted) {
    globalStore.toast("SUCCESS", "Resource deleted");
    return router.push(`/dashboard/resources`);
  }

  return globalStore.toast("ERROR", "Error deleting resource");
}

async function fetchResource() {
  try {
    if (!route.params.id || isNaN(Number(route.params.id))) {
      window.location.href = "/error";
    }

    resource.value = (await api.resources.getResource(String(route.params.id))).data.resource;

    if (!userIsAdmin.value && resource.value.paid && !user.value.show_paid_resources) {
      window.location.href = "/error";
    }
  } catch (error) {
    globalStore.toast("ERROR", "Error fetching resource");
    window.location.href = "/error";
  }
}

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchResource())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationModal, {
      buttonText: "Delete Resource",
      isOpen: isConfirmationModalOpen.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isConfirmationModalOpen.value = false)),
      onDelete: deleteResource
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TitleHeader, {
          title: resource.value.title
        }, null, 8, ["title"]),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(resource.value.subtitle), 1),
        (resource.value?.user?.organisation?.name)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_5, [
              _createTextVNode(" Submitted by: "),
              _createElementVNode("span", _hoisted_6, _toDisplayString(resource.value.user.organisation.name), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(userIsAdmin) && resource.value.paid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Paid Resource"))
          : _createCommentVNode("", true)
      ]),
      _createVNode(RoleGuard, {
        roles: ['admin'],
        class: "flex w-full mt-4 space-x-4 md:mt-0 md:justify-end md:w-1/2"
      }, {
        default: _withCtx(() => [
          _createVNode(RouterButton, {
            type: "primary",
            to: { path: `/dashboard/resources/${resource.value.id}/edit` }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Edit Resource")
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(DefaultButton, {
            type: "danger",
            loading: false,
            disabled: false,
            onAction: _cache[1] || (_cache[1] = ($event: any) => (isConfirmationModalOpen.value = !isConfirmationModalOpen.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Delete Resource")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(ListRowItem, {
          title: "Type",
          showDivider: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_10, _toDisplayString(getResourceType(resource.value.type)), 1)
          ]),
          _: 1
        }),
        _createVNode(ListRowItem, {
          title: "Language",
          class: "bg-play-gray",
          showDivider: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_11, _toDisplayString(resource.value.language), 1)
          ]),
          _: 1
        }),
        _createVNode(RoleGuard, { roles: ['admin'] }, {
          default: _withCtx(() => [
            _createVNode(ListRowItem, {
              title: "Visibility",
              showDivider: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource.value.roles.filter(i => i.name !== 'admin').sort((a, b) => a.order - b.order), (role, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "block space-x-2 capitalize",
                      key: index
                    }, _toDisplayString(_ctx.$t(role.name)), 1))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ListRowItem, {
          title: "Tags",
          class: "bg-play-gray",
          showDivider: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(ReadonlyTags, {
                tags: resource.value.tags
              }, null, 8, ["tags"])
            ])
          ]),
          _: 1
        }),
        _createVNode(ListRowItem, { title: "Cover Image" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: resource.value.thumbnail ? resource.value.thumbnail : 'https://placeholder.com/400x400.png',
                alt: "Thumbnail",
                class: "w-64 h-64"
              }, null, 8, _hoisted_14)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(ListRowItem, {
          title: _ctx.$t('files-download')
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["title"]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            (resource.value.files)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource.value.files, (file, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "text-lg text-blue-500 underline"
                    }, [
                      _createElementVNode("a", {
                        href: file.file_path
                      }, _toDisplayString(file.name) + " (" + _toDisplayString(formatBytes(file.size)) + ")", 9, _hoisted_18)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (resource.value.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", {
              innerHTML: resource.value.description,
              class: "description-body"
            }, null, 8, _hoisted_20)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})